import "./FrameProductVideo.css";

export default function FrameProductVideo({ videoSrc, title, description, label, wide = false }) {
  return (
    <section className={wide ? "frame-product-video frame-product-video--wide" : "frame-product-video"} aria-label={label || title}>
      <div className="frame-product-video-copy">
        <p>Ver el marco en uso</p>
        <h2>{title}</h2>
        {description && <span>{description}</span>}
      </div>

      <div className="frame-product-video-media">
        <video
          src={videoSrc}
          muted
          loop
          autoPlay
          playsInline
          preload="metadata"
          aria-label={label || title}
        />
      </div>
    </section>
  );
}
